<template>
  <textarea
    class="ps-autosize ps-block form-textarea  border-4 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 "
    ref="textarea"
    :placeholder="placeholder"
    :value.prop="value"
    @input="update"
    @focus="$emit('input-focus', $event.target.value)"
    @blur="$emit('input-blur', $event.target.value)"
    rows="1"
    placeholder="Add Your thoughts..."
    @keydown.enter="coordinateSubmit"
  ></textarea>
</template>

<script>
import autosize from 'autosize'

export default {
  name: 'BaseTextarea',
  props: {
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    vuelidate: {
      type: Object
    },
    initialHeight: {
      type: Number,
      default: 56
    },
    reset: {
      type: Number
    }
  },
  async mounted() {
    autosize(this.$refs.textarea)
    this.$refs.textarea.addEventListener(
      'autosize:resized',
      this.textAreaResized
    )
    await this.$nextTick()
    this.resetTextArea()
  },
  watch: {
    value(val) {
      if (!val) {
        this.resetTextArea()
      }
    }
  },
  methods: {
    update($event) {
      this.vuelidate.$touch()
      this.$emit('input', $event.target.value)
    },
    resetTextArea() {
      if (!this.$refs.textarea) return
      this.$refs.textarea.style.height = `${this.initialHeight}px`
      this.$refs.textarea.style.minHeight = `${this.initialHeight}px`
      this.textAreaResized()
    },
    textAreaResized() {
      if (!this.$refs.textarea) return
      let newHeight = parseInt(this.$refs.textarea.style.height)
      this.$emit(
        'autosize',
        newHeight < this.initialHeight ? this.initialHeight : newHeight
      )
    },
    coordinateSubmit(e) {
      if (!e.shiftKey) {
        e.preventDefault()
        this.$emit('enter')
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-autosize {
  max-height: 400px !important;
  transition: height 400ms ease;
}
</style>
